import { useEffect, useState } from "react";
import type React from "react";
import { Box } from "@mui/material";
import { resolveSpecsImageUrl } from "../specsAssetUrls";

export function SpecsAssetImage({
  src,
  alt,
  sx,
}: {
  src?: string | null;
  alt: string;
  sx?: React.ComponentProps<typeof Box>["sx"];
}) {
  const resolvedSrc = resolveSpecsImageUrl(src);
  const needsAuthFetch =
    !!resolvedSrc &&
    !resolvedSrc.startsWith("data:") &&
    !resolvedSrc.startsWith("blob:") &&
    !/^https?:\/\//i.test(resolvedSrc);
  const [blobUrl, setBlobUrl] = useState<string>("");

  useEffect(() => {
    if (!resolvedSrc) {
      setBlobUrl("");
      return;
    }

    if (!needsAuthFetch) {
      setBlobUrl(resolvedSrc);
      return;
    }

    let cancelled = false;
    let objectUrl = "";

    fetch(resolvedSrc, {
      headers: {
        "x-api-key": process.env.REACT_APP_DESIGN_STATE_API_KEY || "",
      },
    })
      .then(async (response) => {
        if (!response.ok) {
          throw new Error(`Failed to load asset: ${response.status}`);
        }
        return response.blob();
      })
      .then((blob) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setBlobUrl(objectUrl);
      })
      .catch(() => {
        if (!cancelled) setBlobUrl("");
      });

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [resolvedSrc, needsAuthFetch]);

  if (!blobUrl) return null;

  return <Box component="img" src={blobUrl} alt={alt} sx={sx} />;
}
